// @flow

import React from 'react';

import { Screen } from '@zapier/theme';
import { UpcomingAppRequestForm } from '@zapier/design-system-app-profiles';
import { useMediaProps } from '@zapier/common-components';

import ApolloQuery from 'web-ssr/app/common/components/ApolloQuery';
import upcomingAppRequestFormQuery from 'web-ssr/app/app-directory/components/UpcomingAppRequestForm/upcomingAppRequestFormQuery';

import type {
  upcomingAppRequestFormQuery as upcomingAppRequestFormQueryType,
  upcomingAppRequestFormQueryVariables,
} from 'web-ssr/graphql/types';

type Result = {
  loading: *,
  fetchMore: *,
  error: *,
  data: upcomingAppRequestFormQueryType,
};

type Props = {
  appSlug: string,
};

const UpcomingAppRequestFormContainer = (props: Props) => {
  const variables: upcomingAppRequestFormQueryVariables = {
    slug: props.appSlug,
  };

  const layoutProps = useMediaProps({
    [Screen.queries.phone]: { size: 'small' },
    [Screen.queries.phablet]: { size: 'small' },
    [Screen.queries.tablet]: { size: 'medium' },
    [Screen.queries.desktop]: { size: 'large' },
  });

  return (
    <ApolloQuery query={upcomingAppRequestFormQuery} variables={variables}>
      {({ data }: Result) => {
        const { appBySlug } = data || {};

        if (!appBySlug || !appBySlug.isUpcoming) {
          return null;
        }

        return (
          <UpcomingAppRequestForm
            appIconSrc={appBySlug.image || ''}
            appName={appBySlug.name}
            size={layoutProps.size}
          />
        );
      }}
    </ApolloQuery>
  );
};

export default UpcomingAppRequestFormContainer;
